<template>
  <div class='account'>

    <navigator class='header' :title="title"></navigator>
    <div class="tabclass" v-if="Newslist.length">
      <div class="heads">
        <div>消息编号</div>
        <div>消息内容</div>
        <div>发送时间</div>
      </div>
      <div class="cont" v-for="(item, index) in Newslist" :key="index">
        <div>{{item.noticeId}}</div>
        <div>{{item.noticeContent}}</div>
        <div>{{item.createTime | DateFilter('yyyy-MM-dd')}}</div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  data(){
    return {
      title: '历史消息',
      qiniuConfig: {},
      Newslist:[],
      zhlist:[],
    };
  },

  methods: {
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
    getNewslist() {  // 消息列表
      this.$http.post(`${this.URL_PREFIX}/app/get/user/notice/history/list`, {
        parkId: this.currentParkId,
        currPage: 1,
        pageRows: 10,
      },{
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.Newslist = res.resData.pageList;
          console.log(this.Newslist);
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    getzhlist() {  // 流水列表
      this.$http.post(`${this.URL_PREFIX}/mgmt/park/finance/payLogList`, {
        park_id: this.currentParkId,
        curr_page: 1,
        page_rows: 15,
      },{
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.zhlist = res.resData.page_list;
          console.log(this.zhlist);
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
  },
  computed: {
    ...mapGetters(['token', 'currentParkId']),
  },
  created() {
    this.getUploadToken();
    this.getNewslist();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.account{
  .header{
    margin-bottom: .133333rem;
  }
  .tabclass{
    padding: .38rem .5rem;
    height: 100%;
    background: #fff;
    float: left;
    .heads{
      height: 1.2rem;
      div{
        background: #205eff;
        color: #fff;
        text-align: center;
        float: left;
        border: 1px solid #c7b9b9;
        height: 1.2rem;
        line-height: 1.2rem;
        &:nth-child(1){
          width: 24%;
        }
        &:nth-child(2){
          width: 50%;
          border-left: none;
          border-right: none;
        }
        &:nth-child(3){
          width: 24%;
        }
      }
    }
    .cont{
      div{
        color: #9c9696;
        text-align: center;
        float: left;
        border: 1px solid #c7b9b9;
        height: 3rem;
        overflow: hidden;
        font-size: .37rem;
        &:nth-child(1){
            width: 24%;
            line-height: 3rem;
        }
        &:nth-child(2){
          width: 50%;
          border-left: none;
          border-right: none;
          display: flex;
          align-items: center;
        }
        &:nth-child(3){
          width: 24%;
          line-height: 3rem;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/News.vue